import { utl_parseData } from "../base/_utils";
import Papa from "papaparse";
import "../base/_jquery-global";
import "bootstrap-table";

document.addEventListener("DOMContentLoaded", () => {
    async function getAndDisplayData() {
        const boardData = "https://docs.google.com/spreadsheets/d/e/2PACX-1vQ6tnUNLHRBJMhOmEq7xm8vwqI6yLj_Ui1yPgMJZXSdA89hs6mJfW3jMdI8OSjf23HPxwTK1SaY5J6r/pub?gid=452737925&single=true&output=csv";

        try {
            // 'await' allows/prevents execution of parseData() depending on resolution/rejection of Promise
            const results = await utl_parseData(boardData, Papa);
            const data = results.data;
            let $table = $("#board-table");

            $(function () {
                $table.bootstrapTable({
                    pagination: true,
                    search: true,
                    data: data,
                });
                document.querySelector(".loading-wrap").remove();
            });
        } catch (error) {
            // If Promise rejects, log the error
            console.error("Error parsing data:", error);
        }
    }
    getAndDisplayData();
});
